// extracted by mini-css-extract-plugin
export default {"observers__arrowIcon":"observers_observers__arrowIcon__qKeFS"};